'use strict';

const util = {
  isOptionAvailable(dealOptions, optionUuid) {
    const option = dealOptions.find(
      currentOption => currentOption.uuid === optionUuid
    );
    if (option) {
      const isSoldOut = option.isSoldOut;
      const isUnavailable = option.status !== 'open';
      return !(isSoldOut || isUnavailable);
    }
    return false;
  },
  isTraitAvailable(traitOptions, dealOptions) {
    return traitOptions.some(optionId =>
      util.isOptionAvailable(dealOptions, optionId)
    );
  },
  isPartOfCurrentSelection(traitOptions, dealOptions) {
    return traitOptions.some(optionId =>
      dealOptions.some(currentOption => currentOption.uuid === optionId)
    );
  },
};

module.exports = util;
